<template>
  <div class="home">
    <loading-overlay :active="isLoading" :is-full-page="true" />
    <div class="container">
      <div class="card" style="width:35rem">
        <div class="card-body">
          <h5 class="card-title text-start">Please enter your key</h5>
          <input type="text" class="form-control mb-3" v-model="code">
          <button class="btn btn-tracking float-end" @click="login">Login</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const store = window.require('../store')
// const Store = window.require('electron-store');
// const store = new Store();
// console.log(store.get('apiToken'))
// const electron = window.require("electron")

export default {
  name: 'loginPage',
  components: {

  },
  data(){
    return{
      code: '',
      isLoading: false
    }
  },
  mounted(){
    // this.isLoading = true;
    
  },
  methods: {
    login(){

      if(!window.matchMedia('(display-mode: standalone)').matches){
        this.$router.push({ name : 'install'})
        return;
      }

      this.isLoading = true;
      this.axios.post(`https://${process.env.VUE_APP_DOMAIN}/api/software/login`,{
          code: this.code,
          name: 'Delivery Code Software - '+window.localStorage.getItem('username')
      }).then(res => {
        if(res.data.apiToken){
          localStorage.setItem('apiToken',res.data.apiToken)
          localStorage.setItem('couriers',JSON.stringify(res.data.couriers))
          this.$swal({
            icon: 'success',
            title: 'System Reminder',
            text: 'Login Successfully',
            confirmButtonColor: '#ff6700'
          })
          this.isLoading = false;
          this.$router.push({name: 'home'});
        }
      }).catch(err => {
        this.isLoading = false;
        if(err.response){
          if(err.response.status == 500 || err.response.status == 405){
            this.$swal({
              icon: 'error',
              title: 'Oops.. Something Wrong',
              text: 'Please contact Tracking.my IT department',
              confirmButtonColor: '#ff6700'
            })
          }else{
            this.$swal({
              icon: 'error',
              title: 'System Reminder!',
              text: 'Invalid Token',
              confirmButtonColor: '#ff6700'
            })
          }
        }else{
          this.$swal({
            icon: 'error',
            title: 'Oops.. Something Wrong',
            text: 'Please contact Tracking.my IT department',
            confirmButtonColor: '#ff6700'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

.container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  height: 100px;
  width: 200px;
  background: #fff;
  padding: 50px;
  border-radius: 10px;
  position: relative;
  text-align: center;
}

.btn-tracking{
  font-size: 55%!important;
  border-color: #ff6700;
  color: #ff6700;
}


</style>
